module.exports = __webpack_public_path__ + "img/8N.a4c593ec.png";